<template>
    <div>
        <div class="flex">
<!--        <el-row class="marB10">-->
<!--            <el-col :span="10"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}" class="bor">-->
            <div :style="{height: tableHeight+100+'px',minWidth: '300px',width:'calc(50% - 70px)',overflow: 'auto'}" class="bor">
                <el-tree
                        ref="tree"
                        :data="treeData"
                        lazy
                        :load="loadNode"
                        :props="defaultProps"
                        node-key="i_obj"
                        class="trees  video-tree height100"
                        accordion
                        show-checkbox
                        @check-change="handleCheckChange"
                        @check="checktree"
                        :check-strictly="true"
                        :highlight-current='true'
                        :expand-on-click-node="false">
                    <!--      -->
                    <!---->
                </el-tree>
            </div>
            <div :style="{height: tableHeight+100+'px',width:'140px'}" class="bor">
<!--            </el-col>-->
<!--            <el-col :span="4"  style="height: 100%;">-->
                <div :style="{lineHeight:tableHeight+'px',textAlign:'center'}">
                    <el-button class="bcBtn" @click="addChoose" :class="baseerp+'btn'" size="mini" >添加</el-button>
                    <el-button class="bcBtn" @click="deleteChoose" :class="baseerp+'btn'" size="mini">删除</el-button>
                </div>
            </div>
            <div :style="{height: tableHeight+100+'px',minWidth: '300px',width:'calc(50% - 70px)',overflow: 'auto'}" class="bor">
<!--            </el-col>-->
<!--            <el-col :span="10" class="bor"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">-->
                <div class="con" >
                    <el-checkbox-group v-model="rightChoose"@change="handleRightChange">
                        <el-checkbox v-for="item in rightData" v-if="item.flag==0||item.flag==1" :label="item" :key="item.i_obj" style="padding: 5px 0;display: block">
                            {{item.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>

<!--            </el-col>-->
<!--        </el-row>-->
    </div>
        <div class="pz" style="text-align: center">
            <el-button class="bcBtn" @click="saveBtn" :class="baseerp+'btn'" size="mini" >
                确定
            </el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    // import * as API from "./api"
    import * as API from "./../api"
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "TransferTree",
        props:{
            datatype:{
                type: Number,
                required:true,
            },
            pid:{
                type: Number,
                required:true,
            },
            treeChoooseData:{
                type: Array,
                required:true,
            },
        },
        components: {},
        data() {
            return {
                baseerp:'',
                allList:[],
                tableHeight:0,
                search:'',
                choosesearch:'',
                leftChoose:[],
                rightChoose:[],
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_obj'
                },
                rightCheck:false,
                treeData:[],
                tableRightKey:0,
                rightData:[],
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            treeChoooseData:{
                handler() {
                    this.rightData=JSON.parse(JSON.stringify(this.treeChoooseData))
                    this.rightData.map(o=>{
                        o.i_obj=o.vc_obj?o.vc_obj:o.i_obj
                    })
                    // console.log(this.rightData,'this.rightData')
                },
                immediate: true,
                deep:true,
    },

        },
        activated(){
            this.onResize();
        },
        mounted() {

            this.baseerp=baseerp;
            // this.tableData=this.transferData.list
            // this.pageTotal=this.total
            this.$nextTick(()=>{

                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-180

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            addChoose(){
                //console.log(this.leftChoose,'this.leftChoose')
                if (this.leftChoose.length!=0){
                    if (this.datatype==15){
                        //单选
                        for (let r=0;r<this.rightData.length;r++){
                            let d=this.rightData[r]
                            if(d.i_id!==undefined){
                                d.flag=-1
                                d.del=false
                            }else{
                                d.del=true
                            }
                        }
                        this.rightData=this.rightData.filter(i=>i.del==false)
                    }
                    this.leftChoose.forEach(val=>{
                        let at=this.rightData.findIndex(item=>item.i_obj==val.i_obj&&item.flag!=-1);
                        if (at==-1){
                            let obj=val
                            obj.flag=0
                            obj.i_pid=this.pid
                            obj.i_obj=val.i_obj
                            obj.i_type=this.datatype
                            this.rightData.unshift(obj)
                        }
                    })
                    this.$refs.tree.setCheckedNodes([]);
                    this.$nextTick(()=>{
                        this.leftChoose=[]
                    })

                    // this.rightChoose=[]

                }

            },
            deleteChoose(){
                if (this.rightChoose.length>=1) {
                    this.rightData.map((val,index)=> {
                        let at=this.rightChoose.findIndex(item=>item.i_obj==val.i_obj);
                        if (at!==-1) {
                            val.flag = -1
                        }
                    })
                    this.rightData=this.rightData.filter(val =>!(val.flag==-1&&val.i_id==undefined));
                    this.rightChoose=[]
                    // console.log(this.allList,'this.allList')

                }
            },
            saveBtn(){
                this.$emit('choosetree',this.rightData,this.datatype)
            },
            cancel(){
                this.$emit('close')
            },
            handleRightChange(val){
                // console.log(val)
                // if (val.rightCheck){
                //     // let obj=val;
                //     // obj.flag=-1
                //     // obj.i_pid=this.pid
                //     // obj.i_obj=obj.i_obj
                //     // obj.i_type=this.datatype
                //     // obj.rightCheck=true
                //     this.rightChoose.push(val)
                // }else{
                //     let i=this.rightChoose.findIndex(item=>item.i_obj==val.i_obj);
                //     this.rightChoose.splice(i,1)
                // }
                this.$forceUpdate()

            },
            handleNodeClick(val){
                // console.log(val,'treeData')
                // this.$emit('showData',val)


            },
            checktree(node,list){
                // console.log(this.datatype,list.checkedKeys.length,'0000',node)
                /*if(this.datatype==15&&list.checkedKeys.length>1){
                    console.log(111)
                    this.$refs.tree.setCheckedNodes([node]);
                }*/
            },
            handleCheckChange(val,check){
                // let obj=val
                // obj.flag=0
                // obj.i_pid=this.pid
                // obj.i_obj=val.i_obj
                // obj.i_type=this.datatype
                //多选

                //console.log(check,'i')
                if(check){
                    if (this.datatype==15){
                        //单选
                        this.$refs.tree.setCheckedNodes([val]);
                    }
                    this.leftChoose.push(val)
                }else {
                    let i=this.leftChoose.findIndex(one=>one.i_obj==val.i_obj)
                    this.leftChoose.splice(i,1)
                }
                this.$forceUpdate()
            },
            loadNode(node, resolve) {
                // console.log(this.treeData,'treeData');
                let _this=this;
                if (node.level === 0) {
                    let val={
                        i_obj:0,
                        i_level:1,
                        i_state:0,

                    }
                    setTimeout(() => {
                        if (this.datatype==3){
                            _this.getProductTree(val,resolve);
                        }else if (this.datatype==4){
                            _this.getCompanyTree(val,resolve);
                        }else if (this.datatype==6||this.datatype==15||this.datatype==32||this.datatype==33){
                            _this.getDeptTree(val,resolve);
                        }else if (this.datatype==28 ){
                            _this.getYwTypeList(val,resolve);
                        }

                    }, 100)
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    if (this.datatype==3){
                        _this.getProductTree(node.data,resolve);
                    }else if (this.datatype==4){
                        _this.getCompanyTree(node.data,resolve);
                    }else if (this.datatype==6||this.datatype==15||this.datatype==32||this.datatype==33){
                        _this.getDeptTree(node.data,resolve);
                    }else if (this.datatype==28){
                        _this.getYwTypeList(node.data,resolve);
                    }
                }
            },
            async getDeptTree({i_obj=0,i_state=0},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                    // i_isuse:1,
                    // isiysuser:0,
                    // withPerson:1
                };
                let res = await API.getDeptTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,
                                // i_pid:one.i_pid,
                                isLeaf: one.haschild==0,
                                disabled:(this.datatype==15||this.datatype==32||this.datatype==33)&&one.haschild==1,
                            };
                            // let hash= one;
                            //     one.wyid= one.i_id+'_'+one.i_pid+'_'+one.nodeType;
                            //     one.label=one.vc_name;
                            //     one.i_obj=one.i_id;
                            //     i_state=one.i_state;
                            //     one.rightCheck=false;
                            //     // i_pid:one.i_pid,
                            //     one.isLeaf= !one.hasSubPerson&&!one.hasSubDept;
                            //     one.disabled=(this.datatype==15||this.datatype==32||this.datatype==33)&&(one.hasSubPerson||one.hasSubDept);

                            list.push(hash);
                        })
                    }
                    // console.log(list,'tree')
                    // if (pid!=0){
                    return resolve(list);
                    // }else {
                    //     this.treeData=list
                    // }

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getCompanyTree({i_obj=0,i_state=0},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                };
                let res = await API.getCompanyTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,
                                // i_pid:one.i_pid,
                                isLeaf: one.haschild==0,
                            };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getProductTree({i_obj=0,i_state=0},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                };
                let res = await API.getProductTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,
                                // i_pid:one.i_pid,
                                isLeaf: one.haschild==0,
                            };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getYwTypeList({i_obj=0,i_state=0},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                };
                let res = await API.getYwTypeList(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                rightCheck:false,
                                // i_pid:one.i_pid,
                                isLeaf: one.haschild==0,

                            };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .marL5{
        margin-left: 5px;
    }
    .marB10{
        margin-bottom: 10px;
    }
    .bor{
        border: 1px solid #ebeef5;
        padding: 8px 10px;
        border-radius: 5px;
    }
    /deep/{
        .el-tree{
            width: fit-content;
        }
        .el-checkbox__label{
            width: fit-content;
        }
    }
</style>